var React = require('react');

function IconB3Previous (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("circle",{"opacity":"0.8","fill":"#FFFFFF","cx":"15.999","cy":"16","r":"15.999","key":0}),React.createElement("g",{"key":1},React.createElement("path",{"fill":"#3C3C3B","d":"M18.859,9.729c0.142,0,0.283,0.054,0.388,0.16c0.216,0.215,0.216,0.561,0,0.777L13.914,16l5.333,5.334\n\t\t\tc0.216,0.214,0.216,0.56,0,0.775c-0.214,0.215-0.56,0.215-0.774,0l-5.723-5.722c-0.214-0.214-0.214-0.561,0-0.776l5.723-5.722\n\t\t\tC18.579,9.783,18.72,9.729,18.859,9.729z"}))]));
}

IconB3Previous.displayName = "IconB3Previous";

IconB3Previous.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 32 32","enableBackground":"new 0 0 32 32","xmlSpace":"preserve"};

module.exports = IconB3Previous;

IconB3Previous.default = IconB3Previous;
